"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAvatar = void 0;
var React = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./UserAvatar.css"));
var GRAVATAR_DEFAULT_AVATAR = "https://www.gravatar.com/avatar";
var makeName = function (name) {
    if (name.includes(" ")) {
        var _a = __read(name.split(" "), 2), firstName = _a[0], lastName = _a[1];
        return { firstName: firstName, lastName: lastName };
    }
    if (name.includes("@")) {
        var _b = __read(name.split("@"), 1), firstName = _b[0];
        return { firstName: firstName, lastName: "" };
    }
    return { firstName: name, lastName: "" };
};
var UserAvatar = function (props) {
    var name = props.name, url = props.url, size = props.size;
    var _a = makeName(name), firstName = _a.firstName, lastName = _a.lastName;
    var image = url.includes(GRAVATAR_DEFAULT_AVATAR) ? "" : url;
    if (size === "custom") {
        return (React.createElement("div", { className: styles.userAvatar, style: { width: "".concat(props.width, "px"), height: "".concat(props.width, "px") } },
            React.createElement(kaleidoscope_1.Avatar, { className: styles.klAvatarOverride, image: image, firstName: firstName, lastName: lastName, size: kaleidoscope_1.AvatarSize.Large })));
    }
    var avatarSize = size === "small" ? kaleidoscope_1.AvatarSize.Small : kaleidoscope_1.AvatarSize.Large;
    return (React.createElement(kaleidoscope_1.Avatar, { image: image, firstName: firstName, lastName: lastName, size: avatarSize, className: styles.klAvatar }));
};
exports.UserAvatar = UserAvatar;
